import {FormattedMessage} from 'react-intl';

import {Avatar} from '@time-webkit/all/atoms/avatar';

import {Constants} from 'utils/constants';
import * as Utils from 'utils/utils';
import {isGuest, isGuestPlus} from 'mattermost-redux/utils/user_utils';

import BotBadge from 'components/widgets/badges/bot_badge';
import GuestPlusBadge from 'components/widgets/badges/guest_plus_badge';
import GuestBadge from 'components/widgets/badges/guest_badge';
import SharedUserIndicator from 'components/shared_user_indicator';

import Suggestion from '../suggestion';
import CustomStatusEmoji from 'components/custom_status/custom_status_emoji';
import StatusIcon from 'components/status_icon';
import {sendToStatist} from '@time-webkit/statist';
import {getSpecialMentions} from 'features/editor/components/editor/helpers';
import {MegaphoneIcon} from '@time-webkit/all/icons';

const EMOJI_STYLE = {
    margin: '0 4px 4px',
};

const SPECIAL_MENTIONS = getSpecialMentions();

export default class AtMentionSuggestion extends Suggestion {
    handleClick = (event) => {
        event.preventDefault();
        sendToStatist('editor.searchUser.resultTap', {
            resultNumber: this.props.index + 1,
            resultKeyboard: false,
        });
        this.props.onClick({
            index: this.props.index,
            term: this.props.term,
            item: this.props.item,
            matchedPretext: this.props.matchedPretext,
            event,
        });
    }

    render() {
        const isSelection = this.props.isSelection;
        const item = this.props.item;

        let itemname;
        let description;
        let icon;
        let customStatus;
        if (Constants.SPECIAL_MENTIONS.includes(item.username)) {
            itemname = item.username;
            description = (
                <span className='ml-2'>
                    {SPECIAL_MENTIONS?.[itemname]?.displayName}
                </span>
            );
            icon = (
                <FormattedMessage
                    id='generic_icons.member'
                    defaultMessage='Member Icon'
                >
                    {() => (
                        <span className='suggestion-list__icon suggestion-list__icon--large'>
                            <MegaphoneIcon width={16} height={16} />
                        </span>
                    )}
                </FormattedMessage>
            );
        } else if (item.type === Constants.MENTION_GROUPS) {
            itemname = item.name;
            description = `- ${item.display_name}`;
            icon = (
                <FormattedMessage
                    id='generic_icons.member'
                    defaultMessage='Member Icon'
                >
                    {(title) => (
                        <span className='suggestion-list__icon suggestion-list__icon--large'>
                            <i
                                className='icon icon-account-multiple-outline'
                                title={title}
                            />
                        </span>
                    )}
                </FormattedMessage>
            );
        } else {
            itemname = item.username;

            if (item.isCurrentUser) {
                if (item.first_name || item.last_name) {
                    description = (
                        <span className='ml-2'>
                            {Utils.getFullName(item)}
                        </span>
                    );
                }
            } else if (item.first_name || item.last_name || item.nickname) {
                description = (
                    <span className='ml-2'>
                        {`${Utils.getFullName(item)} ${
                            item.nickname ? `(${item.nickname})` : ''
                        }`.trim()}
                    </span>
                );
            }

            icon = (
                <span className='status-wrapper style--none'>
                    <span className='profile-icon'>
                        <Avatar
                            username={item && item.username}
                            size={24}
                            src={Utils.imageURLForUser(item.id, item.last_picture_update)}
                        />
                    </span>
                    <StatusIcon className='status-icon-24' status={item?.status}/>
                </span>
            );

            customStatus = (
                <CustomStatusEmoji
                    showTooltip={true}
                    userID={item.id}
                    emojiSize={15}
                    emojiStyle={EMOJI_STYLE}
                />
            );
        }

        let youElement = null;
        if (item.isCurrentUser) {
            youElement = (
                <span className='you-label'>
                    <FormattedMessage
                        id='suggestion.user.isCurrent'
                        defaultMessage='you'
                    />
                </span>
            );
        }

        let className = 'suggestion-list__item';
        if (isSelection) {
            className += ' suggestion--selected';
        }

        let sharedIcon;
        if (item.remote_id) {
            sharedIcon = (
                <SharedUserIndicator
                    className='shared-user-icon'
                    withTooltip={true}
                />
            );
        }

        return (
            <div
                className={className}
                data-testid={`mentionSuggestion_${itemname}`}
                onClick={this.handleClick}
                onMouseMove={this.handleMouseMove}
                {...Suggestion.baseProps}
            >
                {icon}
                <span className='suggestion-list__ellipsis'>
                    <span className='suggestion-list__main'>
                        {'@' + itemname}
                    </span>
                    <BotBadge
                        show={Boolean(item.is_bot)}
                        className='badge-autocomplete'
                    />
                    {customStatus}
                    {description}
                    {youElement}
                    {sharedIcon}
                    <GuestPlusBadge
                        show={isGuestPlus(item.roles)}
                        className='badge-autocomplete'
                    />
                    <GuestBadge
                        show={isGuest(item.roles)}
                        className='badge-autocomplete'
                    />
                </span>
            </div>
        );
    }
}
